export const USER_PERMISSIONS = {
    ViewSensitiveData: "Permissions.ViewSensitiveData",

    // Client Management
    ViewClient: "Permissions.Client.View",
    CreateClient: "Permissions.Client.Create",
    UpdateClient: "Permissions.Client.Update",
    DisableClient: "Permissions.Client.Disable",

    ViewStateFiling: "Permissions.Client.StateFiling.View",
    CreateStateFiling: "Permissions.Client.StateFiling.Create",
    UpdateStateFiling: "Permissions.Client.StateFiling.Update",

    ViewAdditionalAlems: "Permissions.Client.AdditionalAlems.View",
    CreateAdditionalAlems: "Permissions.Client.AdditionalAlems.Create",
    UpdateAdditionalAlems: "Permissions.Client.AdditionalAlems.Update",
    DeleteAdditionalAlems: "Permissions.Client.AdditionalAlems.Delete",

    ViewAlternateReturnAddress: "Permissions.Client.AlternateReturnAddress.View",
    CreateAlternateReturnAddress: "Permissions.Client.AlternateReturnAddress.Create",
    UpdateAlternateReturnAddress: "Permissions.Client.AlternateReturnAddress.Update",
    DeleteAlternateReturnAddress: "Permissions.Client.AlternateReturnAddress.Delete",

    // File Management
    ViewFileImportHistory: "Permissions.FileImportHistory.View",
    ImportFile: "Permissions.File.Import",
    ImportDelete1095C: "Permissions.DataManagement.Delete1095C",

    // User Management
    ViewUser: "Permissions.User.View",
    CreateUser: "Permissions.User.Create",
    UpdateUser: "Permissions.User.Update",
    DisableUser: "Permissions.User.Disable",

    // 1094-C
    View1094C: "Permissions.Forms.1094C.View",
    Create1094C: "Permissions.Forms.1094C.Create",
    Update1094C: "Permissions.Forms.1094C.Update",
    Delete1094C: "Permissions.Forms.1094C.Delete",

    // 1095-C
    View1095C: "Permissions.Forms.1095C.View",
    Create1095C: "Permissions.Forms.1095C.Create",
    Update1095C: "Permissions.Forms.1095C.Update",
    Hold1095C: "Permissions.Forms.1095C.Hold",
    Delete1095C: "Permissions.Forms.1095C.Delete",
    CreatePrintIndividual: "Permissions.Forms.1095C.CreatePrintIndividual",
    CancelPrintIndividual: "Permissions.Forms.1095C.CancelPrintIndividual",

    // Email Template
    ViewEmailTemplate: "Permissions.EmailTemplate.View",
    CreateEmailTemplate: "Permissions.EmailTemplate.Create",
    UpdateEmailTemplate: "Permissions.EmailTemplate.Update",

    // 1095C Approval Permissions
    View1095CApproval: "Permissions.Forms.1095C.Approval.View",
    L1Approve1095C: "Permissions.Forms.1095C.Approval.L1Approve",
    L2Approve1095C: "Permissions.Forms.1095C.Approval.L2Approve",

    // 1094C Approval Permissions
    View1094CApproval: "Permissions.Forms.1094C.Approval.View",
    L1Approve1094C: "Permissions.Forms.1094C.Approval.L1Approve",
    L2Approve1094C: "Permissions.Forms.1094C.Approval.L2Approve",

    // Print Permissions
    PrintAndFilingActivity: "Permissions.PrintAndFiling.Activity",
    PrintAndFilingActivityRestricted: "Permissions.PrintAndFiling.ActivityRestricted",

    //PrintIndividual Client Permissions
    PrintIndividualClientApproval: "Permissions.PrintIndividualClientApproval",
    PrintIndividualClientCancel: "Permissions.PrintIndividualClientCancel",
    ViewPrintIndividual: "Permissions.ViewPrintIndividual",
    ViewPrintIndividualOverview: "Permissions.ViewPrintIndividualOverview",
    ViewPrintIndividualHistory: "Permissions.ViewPrintIndividualHistory",

    // Reporting Permissions
    ViewReports: "Permissions.Reports.View",
    ViewRestrictedReports: "Permissions.Reports.ViewRestricted",
    DownloadReports: "Permissions.Reports.Download"
} as const;

// ✅ This creates a type that represents any valid permission string
export type User_Permission_Type = (typeof USER_PERMISSIONS)[keyof typeof USER_PERMISSIONS];
